import { useEffect, useRef } from "react"

/**
 * Tracks the current globally active keys without triggering rerenders.
 * The usecases for this are probably pretty limited but feel free to extend
 * the information that is tracked in the ref.
 *
 * Note that it's important that this doesn't trigger renders so that's
 * why we're using a ref instead of state.
 */

export default function useCurrentKeys() {
  const ref = useRef<{
    key: null | string
    shift: boolean
  }>({
    key: null,
    shift: false,
  })

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      ref.current.key = event.key
      ref.current.shift = event.shiftKey
    }
    document.addEventListener("keydown", onKeyDown)

    const onKeyUp = () => {
      ref.current.key = null
      ref.current.shift = false
    }
    document.addEventListener("keyup", onKeyUp)

    return () => {
      document.removeEventListener("keydown", onKeyDown)
      document.removeEventListener("keyup", onKeyUp)
    }
  }, [ref])

  return ref.current
}
